<template>
  <div class="container">
    <!-- 头部banner -->
    <top-banner></top-banner>
    <!-- 轮播 -->
    <img src="@/common/images/mainBusiness/banner_zyyw.png" class="banner_zyyw" />
    <!-- 占位撑开 -->
    <div class="zwmb"></div>
    <!-- menu标题栏 -->
    <div class="menu_mb">
      <div class="mb_menu_item" :class="{'mb_menu_item_active':curIndex==0}" @click="changeCur('0')">信息化智慧应用</div>
      <div class="mb_menu_jg"></div>
      <div class="mb_menu_item" :class="{'mb_menu_item_active':curIndex==1}" @click="changeCur('1')">市场化运营服务</div>
    </div>
    <div class="content_mb" v-if="curIndex=='0'">
      <img src="../common/images/mainBusiness/mb_title.png" class="content_mb_title" />
      <div class="content_mb_line">
        <div class="mb_line_item" v-for="(item,index) in lineList" :key="index" @mouseover="item.show=true"
          @mouseout="item.show=false">
          <img :src="item.imgUrl" class="mb_line_item_img" v-show="!item.show" />
          <img :src="item.imgUrl2" class="mb_line_item_img" v-show="item.show" />
        </div>
      </div>
    </div>
    <div class="content_mb2" v-if="curIndex=='1'">
      <div class="con_1">
        <img src="../common/images/mainBusiness/con1_title.png" class="con1_title" :class="{'zoomIn':showNum==0}" />
        <div class="con1_c">以清扫车、洒水车、护栏清洗车、垃圾清运车等各类环卫机械化设备和“智慧环卫”运营管理技术为标配的环卫作业模式，成为当下环卫市场的主流。</div>
        <div class="con1_b">
          <div class="b_line">
            <img src="../common/images/mainBusiness/bl_1.png" class="bl1" :class="{'fadeInLeft':showNum==0}" />
            <div class="bl_content">
              <div class="bl_cItem" v-for="(item,index) in itemlist_l" :key="index">{{item.title}}</div>
            </div>
          </div>
          <div class="b_line">
            <img src="../common/images/mainBusiness/bl_2.png" class="bl2" :class="{'fadeInLeft':showNum==0}" />
            <div class="bl_content">
              <div class="bl_cItem" v-for="(item,index) in itemlist_r" :key="index">{{item.title}}</div>
            </div>
          </div>
        </div>
        <img src="../common/images/mainBusiness/con1_img.png" class="con1_img" :class="{'zoomInFast':showNum==0}" />
      </div>
      <div class="con_2">
        <img src="../common/images/mainBusiness/con2_title.png" class="con2_title" :class="{'zoomIn':showNum==1}" />
        <div class="con2_c">精细化优秀后期运营维护提供更好的服务</div>
        <div class="con2_img">
          <img src="../common/images/mainBusiness/con2_imgbg.png" class="con2_imgbg" :class="{'zoomInFast':showNum==1}" />
          <div class="con2_l">
            <div class="cl_l1" :class="{'fadeInLeft':showNum==1}">厕改管家</div>
            <div class="cl_l2" :class="{'fadeInLeft':showNum==1}">贯彻落实“小厕所，大民生”的重要指导精神</div>
            <div class="cl_l3">
              <div class="cl_l3_item" v-for="(item,index) in itemlist2_l" :key="index" :class="{'fadeInUp':showNum==1}">
                <img :src="item.imgUrl" class="con2_limg" />{{item.title}}
              </div>
            </div>
          </div>
          <div class="r">
            <div class="con2_r">
              <div class="con2_r_item" v-for="(item,index) in itemlist2_r" :key="index">
                <div class="rl_t" :class="{'fadeInUp':showNum==1}">
                  <img :src="item.imgUrl" class="rl_timg" />{{item.title}}
                </div>
                <div class="rl_b" :class="{'fadeInUp':showNum==1}">
                  {{item.content}}
                </div>
              </div>
            </div>
            <div class="con2_r2">
              <div class="con2_r_item" v-for="(item,index) in itemlist2_r2" :key="index">
                <div class="rl_t" :class="{'fadeInDown':showNum==1}">
                  <img :src="item.imgUrl" class="rl_timg" />{{item.title}}
                </div>
                <div class="rl_b" :class="{'fadeInDown':showNum==1}">
                  {{item.content}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="con_3">
        <img src="../common/images/mainBusiness/con3_title.png" class="con3_title" :class="{'zoomIn':showNum==2}" />
        <div class="con3_content">
          <img src="../common/images/mainBusiness/con3_imgbg.png" class="con3_imgbg" :class="{'zoomInFast':showNum==2}" />
          <div class="con3_con">
            <div class="con3_t" :class="{'zoomIn':showNum==2}">
              建设垃圾分类处理设施，完善运输环节;开展垃圾分类知识全面宣传；运用智能化设备，建设精细化垃圾分类示范点，以点带面，精细化示范点严格采用人员督导管理等。
            </div>
            <div class="con3_b">
              <div class="con3_b_item" v-for="(item,index) in itemlist3" :key="index" :class="{'fadeInUp':showNum==2}">
                <div class="dot"></div>{{item.title}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import topBanner from '@/components/topBanner.vue'
  export default {
    components: {
      topBanner,
    },
    data() {
      return {
        curPage: 'mainBusiness',
        curIndex: 0,
        lineList: [{
          imgUrl: require('@/common/images/mainBusiness/zhhw_1.png'),
          imgUrl2: require('@/common/images/mainBusiness/zhhw_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/mainBusiness/gcgh_1.png'),
          imgUrl2: require('@/common/images/mainBusiness/gcgh_2.png'),
          show: false,
        }, {
          imgUrl: require('@/common/images/mainBusiness/ljfl_1.png'),
          imgUrl2: require('@/common/images/mainBusiness/ljfl_2.png'),
          show: false,
        }],
        itemlist_l: [{
          title: '标准化作业管理',
        }, {
          title: '河道清理',
        }, {
          title: '便携化设施管理',
        }, {
          title: '常态化现场考核',
        }, {
          title: '绿化保养',
        }],
        itemlist_r: [{
          title: '专业化智能平台',
        }, {
          title: '垃圾清运',
        }, {
          title: '信息化事件管理',
        }, {
          title: '道路保洁',
        }, {
          title: '畜禽粪污清理',
        }],
        itemlist2_l: [{
          imgUrl: require('@/common/images/mainBusiness/con2_l1.png'),
          title: '调度管理中心',
        }, {
          imgUrl: require('@/common/images/mainBusiness/con2_l2.png'),
          title: '资源化处理中心',
        }, {
          imgUrl: require('@/common/images/mainBusiness/con2_l3.png'),
          title: '干湿分离处理站',
        }, {
          imgUrl: require('@/common/images/mainBusiness/con2_l4.png'),
          title: '有机利用服务站',
        }],
        itemlist2_r: [{
          imgUrl: require('@/common/images/mainBusiness/con2_r1.png'),
          title: '引用信息化管理',
          content: '通过信息化平台管理对服务流程进行全方位有效、实时的监管统计、分析项目的运营管理工作。'
        }, {
          imgUrl: require('@/common/images/mainBusiness/con2_r2.png'),
          title: '加强常态化宣导',
          content: '做好户厕及公厕的使用培训工作，详细的向农户讲解卫生厕所的使用方法及注意事项，说明后续的维修和抽粪流程。'
        }, {
          imgUrl: require('@/common/images/mainBusiness/con2_r3.png'),
          title: '实行项目化运营',
          content: '坚持管护运营本地化市场化、项目化，运营企业在当地设立分公司，组建管理队伍和管护队伍。'
        }],
        itemlist2_r2: [{
          imgUrl: require('@/common/images/mainBusiness/con2_r4.png'),
          title: '打造资源化市场',
          content: '通过市场化服务，将粪污的抽运进行规范化管理，建设科学的粪污处理和资源利用中心，将粪污无害化资源化处理。'
        }, {
          imgUrl: require('@/common/images/mainBusiness/con2_r5.png'),
          title: '推广有机化利用',
          content: '与种粮大户、有机合作社、苗木果园等进行对接利用，合作农户收获的产品，运营企业可利用自有平台帮扶和协助销售'
        }, {
          imgUrl: require('@/common/images/mainBusiness/con2_r6.png'),
          title: '实践无害化处理',
          content: '通过与市政体系结合运营企业负责抽污与运输，直接与污水处理厂或粪污处理厂进行对接，实现全面的无害化处理。'
        }],
        itemlist3: [{
          title: '基础设施建设'
        }, {
          title: '运输车辆配置'
        }, {
          title: '普及宣传'
        }, {
          title: '运输管理'
        }, {
          title: '垃圾处置管理"'
        }, {
          title: '垃圾分类标准'
        }, {
          title: '智能化设备的应用'
        }, {
          title: '管理系统平台的应用'
        }, {
          title: '服务形式'
        }],
        showNum: 0,
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScrollbox, true)
    },
    methods: {
      changeCur(e) {
        this.curIndex = e
      },

      handleScrollbox() {
        this.currentScroll = window.pageYOffset //表示当前滚动的位置
        var browerWidth = window.innerWidth; //浏览器可视宽度
        var baseWidth = 1920; //设计稿宽度
        var zoomValue = browerWidth / baseWidth; //缩放比例计算
        if (1400 * zoomValue < this.currentScroll && this.currentScroll <= 2300 * zoomValue) {
          this.showNum = 1
        } else if (2300 * zoomValue < this.currentScroll && this.currentScroll <= 3000 * zoomValue) {
          this.showNum = 2
        } else {
          this.showNum = 0
        }
      },
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScrollbox, true)
    }
  }
</script>

<style>
  .container {
    position: relative;
  }

  .banner_zyyw {
    width: 1920px;
    height: 890px;
    z-index: 0;
    position: absolute;
    top: 0;
    left: 0;
  }

  .zwmb {
    width: 1920px;
    height: 890px;
  }

  .menu_mb {
    width: 1920px;
    height: 95px;
    box-shadow: 0px 20px 20px -20px #ededed;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
  }

  .mb_menu_jg {
    width: 1px;
    height: 36px;
    background: #c3c3c3;
  }

  .mb_menu_item {
    width: 959px;
    line-height: 95px;
    text-align: center;
    justify-content: center;
    align-items: center;
    font-size: 28px;
    border-top: 10px solid #ffffff;
  }

  .mb_menu_item_active {
    border-top: 10px solid #23adcc;
  }

  .content_mb {
    width: 1920px;
    height: 1100px;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
  }

  .content_mb2 {
    width: 1920px;
    height: 2900px;
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
  }

  .content_mb_title {
    width: 725px;
    height: 109px;
    margin: 60px auto;
  }

  .content_mb_line {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .mb_line_item {
    width: 450px;
    height: 575px;
    margin: 40px;
  }

  .mb_line_item_img {
    width: 450px;
    height: 575px;
  }

  .con_1 {
    width: 1920px;
    padding-top: 60px;
    height: 1040px;
    position: relative;
  }

  .con_2 {
    width: 1920px;
    height: 800px;
    padding-top: 45px;
    position: relative;
    background-color: #e0ebff;
  }

  .con_3 {
    width: 1920px;
    height: 952px;
    position: relative;
  }

  .con1_title {
    width: 674px;
    height: 29px;
    margin: 40px auto;
  }

  .con1_c {
    width: 1200px;
    margin: 10px auto;
    font-size: 24px;
    line-height: 42px;
    color: #717171;
    letter-spacing: 3px;
    text-align: left;
  }

  .con1_b {
    width: 980px;
    height: 640px;
    padding-right: 300px;
    margin: 60px auto;
    display: flex;
    flex-direction: row;
  }

  .b_line {
    width: 490px;
    height: 640px;
    position: relative;
  }

  .bl1 {
    width: 114px;
    height: 637px;
    position: absolute;
    left: -10px;
    top: 5px;
  }

  .bl2 {
    width: 115px;
    height: 637px;
    position: absolute;
    left: -10px;
    top: 5px;
  }

  .bl_content {
    width: 300px;
    height: 640px;
    position: absolute;
    left: 132px;
    top: 0px;
    display: flex;
    flex-direction: column;
  }

  .bl_cItem {
    width: 300px;
    height: 128px;
    line-height: 132px;
    font-size: 30px;
    text-align: left;
    animation-name: fadeInUp;
    animation-duration: 2s;
  }

  .con1_img {
    width: 628px;
    height: 536px;
    position: absolute;
    right: 100px;
    bottom: 40px;
  }

  .con2_title {
    width: 271px;
    height: 29px;
    margin: 20px auto;
  }

  .con2_c {
    width: 1200px;
    line-height: 24px;
    margin: 0 auto;
    font-size: 24px;
    color: #898989;
    letter-spacing: 4px;
  }

  .con2_img {
    width: 1183px;
    height: 519px;
    position: relative;
    margin: 52px auto;
    display: flex;
    flex-direction: row;
  }

  .con2_imgbg {
    width: 1183px;
    height: 519px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .zoomIn {
    animation-name: zoomIn;
    animation-duration: 2s;
  }
  .zoomInFast {
    animation-name: zoomIn;
    animation-duration: 1s;
  }

  .fadeInLeft {
    animation-name: fadeInLeft;
    animation-duration: 2s;
  }

  .fadeInUp {
    animation-name: fadeInUp;
    animation-duration: 2s;
  }
  .fadeInDown {
    animation-name: fadeInDown;
    animation-duration: 2s;
  }

  .fadeInLeft {
    animation-name: fadeInLeft;
    animation-duration: 2s;
  }

  .con2_l {
    width: 354px;
    height: 500px;
    padding-top: 19px;
    z-index: 9;
  }

  .r {
    display: flex;
    flex-direction: column;
  }

  .con2_r {
    width: 810px;
    height: 250px;
    padding-left: 19px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    z-index: 9;
  }

  .con2_r2 {
    width: 810px;
    height: 250px;
    padding-left: 19px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    z-index: 9;
    margin-top: -12px;
  }

  .cl_l1 {
    margin: 20px 45px;
    color: #fff;
    font-size: 24px;
    line-height: 29px;
    letter-spacing: 4px;
    text-align: left;
  }

  .cl_l2 {
    font-size: 16px;
    line-height: 22px;
    letter-spacing: 3px;
    color: #ffffff;
    margin: 0 42px;
    text-align: left;
  }

  .cl_l3 {
    margin: 80px 42px;
    color: #ffffff;
  }

  .cl_l3_item {
    font-size: 18px;
    letter-spacing: 3px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 15px auto;
  }

  .con2_limg {
    width: 29px;
    height: 30px;
    margin-right: 10px;
  }

  .con2_r_item {
    width: 270px;
    height: 228px;
    /* padding-top: 8px; */
  }

  .rl_t {
    color: #101010;
    font-size: 18px;
    letter-spacing: 3px;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0 20px;
    padding-top: 28px;
  }

  .rl_b {
    font-size: 18px;
    line-height: 24px;
    letter-spacing: 3px;
    color: #919191;
    margin: 20px 32px;
    text-align: left;
  }

  .rl_timg {
    width: 42px;
    height: 44px;
    margin-right: 20px;
  }

  .con3_title {
    width: 271px;
    height: 29px;
    margin: 60px auto;
  }

  .con3_content {
    width: 1571px;
    height: 692px;
    position: relative;
    margin: 0 auto;
  }

  .con3_imgbg {
    width: 1571px;
    height: 692px;
    position: absolute;
    top: 0;
    left: 0;
  }

  .con3_con {
    width: 620px;
    height: 500px;
    position: absolute;
    z-index: 9;
    left: 80px;
    top: 100px;
  }

  .con3_t {
    width: 620px;
    margin: 28px auto;
    text-align: left;
    font-size: 24px;
    line-height: 29px;
    letter-spacing: 4px;
    color: #5a5a5a;
  }

  .con3_b {
    width: 620px;
    font-size: 24px;
    letter-spacing: 4px;
    color: #949494;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .con3_b_item {
    width: 310px;
    height: 70px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  .dot {
    width: 14px;
    height: 15px;
    background-color: #116cf7;
    border-radius: 7px;
    margin-right: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/views/mainBusiness.vue